/*@flow*/

export default () => {
  const node = document.querySelector('body');
  if (node) {
    const ev = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    node.dispatchEvent(ev);
  }
};
